/** Подтверждение серверного расчёта до сохранения адреса. */
export function confirmAddressChange(change) {
    return new Promise(resolve => {
        const dialog = document.createElement('dialog');
        dialog.className = 'border rounded shadow p-4';
        dialog.style.maxWidth = 'min(560px, 95vw)';
        const title = document.createElement('h5');
        title.textContent = 'Изменение условий доставки';
        dialog.append(title);
        const priceRows = [];
        for (const order of change.orders) {
            if (order.new_method) {
                const details = document.createElement('p');
                details.textContent = `${order.new_method}: ${order.new_provider}.`
                    + (order.new_address ? ` Адрес: ${order.new_address}.` : '');
                dialog.append(details);
            }
            const row = document.createElement('p');
            priceRows.push({order, row});
            dialog.append(row);
        }
        const keep = document.createElement('input');
        keep.type = 'checkbox';
        keep.checked = !!change.keeping_price;
        if (change.can_keep_price) {
            const label = document.createElement('label');
            label.className = 'd-block mb-3';
            label.append(keep, document.createTextNode(' Сохранить прежнюю стоимость доставки'));
            dialog.append(label);
        }
        const actions = document.createElement('div');
        actions.className = 'd-flex gap-2 justify-content-end';
        const cancel = document.createElement('button');
        cancel.className = 'btn btn-secondary';
        cancel.textContent = 'Отмена';
        const accept = document.createElement('button');
        accept.className = 'btn btn-primary';
        const updateLabel = () => {
            let refund = 0;
            for (const {order, row} of priceRows) {
                const quote = order.price_options?.[keep.checked ? 'kept' : 'calculated']
                    ?? {price: order.new_price, due: order.due, refund: order.refund};
                refund += Number(quote.refund);
                row.textContent = `Заказ ${order.number}: доставка ${order.old_price} → ${quote.price} ₽.`
                    + (quote.due > 0 ? ` Требуется доплата ${quote.due} ₽.` : '')
                    + (!keep.checked && order.manual_settlement_required
                        ? ' Уменьшение недоступно до ручного урегулирования оплаты с магазином.'
                        : quote.refund > 0 ? ` Будет возвращено ${quote.refund} ₽.` : '');
            }
            accept.disabled = !keep.checked && change.orders.some(order => order.manual_settlement_required);
            accept.textContent = refund > 0 ? `Сохранить адрес и вернуть ${refund.toFixed(2)} ₽`
                    : keep.checked ? 'Сохранить с прежней стоимостью' : 'Подтвердить и сохранить';
        };
        keep.addEventListener('change', updateLabel);
        updateLabel();
        const finish = result => {
            dialog.close();
            dialog.remove();
            resolve(result);
        };
        cancel.addEventListener('click', () => finish(null));
        accept.addEventListener('click', () => finish({confirmation_token: change.token, keep_delivery_price: keep.checked}));
        dialog.addEventListener('cancel', event => { event.preventDefault(); finish(null); });
        actions.append(cancel, accept);
        dialog.append(actions);
        document.body.append(dialog);
        dialog.showModal();
    });
}

export async function withAddressConfirmation(send, data) {
    let payload = data;
    while (true) {
        const response = await send(payload);
        const change = response.data?.address_change_confirmation;
        if (!change) return response;
        const answer = await confirmAddressChange(change);
        if (!answer) {
            const error = new Error('Изменение адреса отменено');
            error.name = 'CanceledError';
            throw error;
        }
        payload = {...payload, ...answer};
    }
}
